(function () {
  "use strict";

  var TAG = "rafe-editorial-carousel";
  var DEFAULT_INTERVAL = 3500;
  var REDUCED_NUM = 153, REDUCED_DEN = 100; /* 1.53x, same ratio as the gate showcase */
  var RESUME_DELAY = 4500;

  if (window.customElements && customElements.get(TAG)) return;

  function Carousel() { return Reflect.construct(HTMLElement, [], Carousel); }
  Carousel.prototype = Object.create(HTMLElement.prototype);
  Carousel.prototype.constructor = Carousel;
  Object.setPrototypeOf(Carousel, HTMLElement);

  Carousel.prototype.connectedCallback = function () {
    this.track = this.querySelector("[data-rafe-track]");
    this.slides = [].slice.call(this.querySelectorAll(".rafe-band__slide"));
    this.dots = [].slice.call(this.querySelectorAll(".rafe-band__dot"));
    this.toggle = this.querySelector("[data-rafe-band-toggle]");
    if (!this.track || !this.slides.length) return;

    this.index = 0;
    this.paused = false;
    this.interacting = false;
    this.baseInterval = parseInt(this.getAttribute("data-interval"), 10) || DEFAULT_INTERVAL;
    this.reduced = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)").matches : false;
    this.applyMotionPreference();
    this.setActive(0);

    if (this.slides.length < 2) {
      this.setAttribute("data-state", "static");
      if (this.toggle) this.toggle.hidden = true;
      return;
    }

    this.setAttribute("data-state", "cycling");

    this.onScroll = this.handleScroll.bind(this);
    this.track.addEventListener("scroll", this.onScroll, { passive: true });

    this.onInteract = this.handleInteract.bind(this);
    this.track.addEventListener("pointerdown", this.onInteract);
    this.track.addEventListener("touchstart", this.onInteract, { passive: true });
    this.track.addEventListener("keydown", this.onInteract);
    this.track.addEventListener("wheel", this.onInteract, { passive: true });

    this.onVisibility = this.handleVisibility.bind(this);
    document.addEventListener("visibilitychange", this.onVisibility);

    if (window.matchMedia) {
      this.mq = window.matchMedia("(prefers-reduced-motion: reduce)");
      this.onMotion = function () {
        this.reduced = this.mq.matches;
        this.applyMotionPreference();
        if (!this.paused) this.start();
      }.bind(this);
      if (this.mq.addEventListener) this.mq.addEventListener("change", this.onMotion);
      else if (this.mq.addListener) this.mq.addListener(this.onMotion);
    }

    if (this.toggle) {
      this.onToggle = this.handleToggle.bind(this);
      this.toggle.addEventListener("click", this.onToggle);
      this.toggle.hidden = false;
      this.reflectToggle();
    }

    var self = this;
    this.dotHandlers = this.dots.map(function (dot, i) {
      var fn = function () { self.bump(); self.goTo(i); };
      dot.addEventListener("click", fn);
      return fn;
    });

    this.hydrateRest();
    this.start();
  };

  Carousel.prototype.applyMotionPreference = function () {
    this.interval = this.reduced
      ? Math.round(this.baseInterval * REDUCED_NUM / REDUCED_DEN)
      : this.baseInterval;
    if (this.reduced) this.setAttribute("data-motion", "reduced");
    else this.removeAttribute("data-motion");
  };

  Carousel.prototype.disconnectedCallback = function () {
    this.stop();
    window.clearTimeout(this.resumeTimer);
    if (this.track && this.onScroll) this.track.removeEventListener("scroll", this.onScroll);
    if (this.track && this.onInteract) {
      this.track.removeEventListener("pointerdown", this.onInteract);
      this.track.removeEventListener("touchstart", this.onInteract);
      this.track.removeEventListener("keydown", this.onInteract);
      this.track.removeEventListener("wheel", this.onInteract);
    }
    if (this.onVisibility) document.removeEventListener("visibilitychange", this.onVisibility);
    if (this.mq && this.onMotion) {
      if (this.mq.removeEventListener) this.mq.removeEventListener("change", this.onMotion);
      else if (this.mq.removeListener) this.mq.removeListener(this.onMotion);
    }
    if (this.toggle && this.onToggle) this.toggle.removeEventListener("click", this.onToggle);
    if (this.dots && this.dotHandlers) {
      for (var i = 0; i < this.dots.length; i++) this.dots[i].removeEventListener("click", this.dotHandlers[i]);
    }
  };

  /* Slide 2 is requested at connect, not on load: the rest follow once the
     first frame is done. Same fix applied to the gate showcase. */
  Carousel.prototype.hydrateRest = function () {
    var self = this;
    var imgs = this.slides.map(function (s) { return s.querySelector("img"); });
    var rest = imgs.slice(1).filter(Boolean);
    if (!rest.length) return;

    var hydrate = function (img) {
      if (img.getAttribute("data-srcset")) {
        img.setAttribute("srcset", img.getAttribute("data-srcset"));
        img.removeAttribute("data-srcset");
      }
      if (img.getAttribute("data-src")) {
        img.setAttribute("src", img.getAttribute("data-src"));
        img.removeAttribute("data-src");
      }
    };

    hydrate(rest[0]);

    var go = function () {
      for (var i = 0; i < rest.length; i++) hydrate(rest[i]);
      self.setAttribute("data-hydrated", "");
    };
    var fired = false;
    var once = function () { if (!fired) { fired = true; go(); } };
    var first = imgs[0];

    if (document.readyState === "complete") once();
    else {
      window.addEventListener("load", once, { once: true });
      if (first && first.complete && first.naturalWidth > 0) once();
      else if (first) {
        first.addEventListener("load", once, { once: true });
        first.addEventListener("error", once, { once: true });
      }
    }
  };

  Carousel.prototype.start = function () {
    var self = this;
    this.stop();
    if (this.paused || this.interacting || document.hidden) return;
    this.timer = window.setInterval(function () { self.advance(); }, this.interval);
  };

  Carousel.prototype.stop = function () {
    if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
  };

  Carousel.prototype.handleVisibility = function () {
    if (document.hidden) this.stop(); else this.start();
  };

  /* A swipe, wheel, key or dot press stands down the timer, then it comes
     back once the visitor has been still for a moment. */
  Carousel.prototype.bump = function () {
    var self = this;
    this.interacting = true;
    this.stop();
    window.clearTimeout(this.resumeTimer);
    this.resumeTimer = window.setTimeout(function () {
      self.interacting = false;
      self.start();
    }, RESUME_DELAY);
  };

  Carousel.prototype.handleInteract = function () { this.bump(); };

  Carousel.prototype.handleToggle = function (e) {
    if (e) e.preventDefault();
    this.paused = !this.paused;
    if (this.paused) { this.stop(); window.clearTimeout(this.resumeTimer); this.interacting = false; }
    else this.start();
    this.reflectToggle();
  };

  Carousel.prototype.reflectToggle = function () {
    if (!this.toggle) return;
    this.toggle.setAttribute("aria-pressed", this.paused ? "true" : "false");
    this.toggle.textContent = this.paused ? "Play" : "Pause";
    this.setAttribute("data-state", this.paused ? "paused" : "cycling");
  };

  Carousel.prototype.advance = function () {
    var next = (this.index + 1) % this.slides.length;
    var img = this.slides[next].querySelector("img");
    if (img && (!img.complete || img.naturalWidth === 0)) return;
    this.goTo(next);
  };

  Carousel.prototype.centreFor = function (slide) {
    return slide.offsetLeft - (this.track.clientWidth - slide.offsetWidth) / 2;
  };

  Carousel.prototype.goTo = function (i) {
    var slide = this.slides[i];
    if (!slide) return;
    var left = this.centreFor(slide);
    if (this.track.scrollTo) {
      this.track.scrollTo({ left: left, behavior: this.reduced ? "auto" : "smooth" });
    } else {
      this.track.scrollLeft = left;
    }
    this.index = i;
    this.setActive(i);
  };

  Carousel.prototype.handleScroll = function () {
    var self = this;
    if (this.raf) return;
    this.raf = window.requestAnimationFrame(function () {
      self.raf = null;
      var centre = self.track.scrollLeft + self.track.clientWidth / 2;
      var best = 0, bestD = Infinity;
      for (var i = 0; i < self.slides.length; i++) {
        var s = self.slides[i];
        var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - centre);
        if (d < bestD) { bestD = d; best = i; }
      }
      self.index = best;
      self.setActive(best);
    });
  };

  Carousel.prototype.setActive = function (i) {
    for (var n = 0; n < this.slides.length; n++) {
      this.slides[n].classList.toggle("is-active", n === i);
      this.slides[n].setAttribute("aria-current", n === i ? "true" : "false");
    }
    for (var d = 0; d < this.dots.length; d++) {
      this.dots[d].classList.toggle("is-active", d === i);
      this.dots[d].setAttribute("aria-current", d === i ? "true" : "false");
    }
    this.setAttribute("data-active", String(i + 1));
  };

  customElements.define(TAG, Carousel);
})();
